import script from "./QuizAnswersField.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuizAnswersField.vue?vue&type=script&lang=ts&setup=true"

import "./QuizAnswersField.vue?vue&type=style&index=0&id=5c4f95b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4f95b5"]])

export default __exports__